






































import { defineComponent, ref } from '@vue/composition-api';
import TextCollectionList from '@/views/Admin/components/TextCollectionList.vue';
import useQueryParam from '@/hooks/useQueryParam';
import sl from '@/serviceLocator';

export default defineComponent({
  components: { TextCollectionList },
  props: {
    groupId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const server = sl.get('serverProxy');
    const types = ref([
      { name: 'Texts', value: 'text' },
      { name: 'Collections', value: 'collection' },
    ]);
    const selectedType = useQueryParam('type', 'text', true);

    return {
      server,
      types,
      selectedType,
    };
  },
});
